import { render, staticRenderFns } from "./PVGISform.vue?vue&type=template&id=49c89494&scoped=true&"
import script from "./PVGISform.vue?vue&type=script&lang=js&"
export * from "./PVGISform.vue?vue&type=script&lang=js&"
import style0 from "./PVGISform.vue?vue&type=style&index=0&id=49c89494&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c89494",
  null
  
)

export default component.exports